<template>
  <Panel
    :header="label"
    :toggleable="true"
    :collapsed="false"
    class="collapsible-section"
    @update:collapsed="$emit('toggle')"
  >
    <MessageRenderer :message="content" />

    <template #togglericon="{ collapsed }">
      <i :class="['pi', collapsed ? 'pi-plus' : 'pi-minus']" />
    </template>
  </Panel>
</template>

<script setup lang="ts">
import MessageRenderer from "@/components/MessageRenderer/MessageRenderer.vue";
import Panel from "primevue/panel";

defineProps({
  content: { type: String, default: "" },
  label: { type: String, required: true },
  isTruncated: { type: Boolean, default: true },
  maxLength: { type: Number, default: 100 },
});

defineEmits(["toggle"]);
</script>

<style lang="scss" scoped>
.collapsible-section {
  margin-bottom: 40px;
  border-radius: 0 !important;
  border: none !important;
  box-shadow: none !important;

  :deep(.p-panel) {
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  :deep(.p-panel-header) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 600;
    color: #1d1d1d;
    padding: 0 0 8px 0;
    background: transparent;
    border: none;
    border-bottom: 1px solid #dfcfe5;
  }

  :deep(.p-panel-title) {
    font-size: 16px;
    font-weight: 600;
    color: #1d1d1d;
    margin: 0;
  }

  :deep(.p-panel-content) {
    font-size: 14px;
    line-height: 1.5;
    color: #1d1d1d;
    margin: 0;
    white-space: pre-wrap;
    padding: 8px 0 0 0;
    background: transparent;
    border: none;
  }

  :deep(.p-panel-toggler) {
    display: flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: none;
    cursor: pointer;
    color: #1d1d1d;
    font-size: 14px;
    padding: 4px;
    width: auto;
    height: auto;
    order: 2;
  }

  :deep(.p-panel-icons) {
    order: 1;
  }

  :deep(.pi) {
    font-size: 16px;
  }
}
</style>
